import styled from 'styled-components';

interface FlexColumnProps {
  flexDirection?: 'column' | 'column-reverse';
  flexWrap?: 'nowrap' | 'wrap' | 'wrap-reverse';
  justifyContent?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'space-between'
    | 'space-around'
    | 'space-evenly';
  alignItems?: 'flex-start' | 'flex-end' | 'center' | 'stretch' | 'baseline';
  alignContent?:
    | 'flex-start'
    | 'flex-end'
    | 'center'
    | 'stretch'
    | 'space-between'
    | 'space-around'
    | 'normal';
  alignSelf?: 'stretch' | 'center' | 'start' | 'end';
  width?: string;
  height?: string;
  gap?: string;
}

export const FlexColumn = styled.div<FlexColumnProps>`
  display: flex;
  ${({ flexDirection }) =>
    flexDirection ? `flex-direction: ${flexDirection}` : 'flex-direction: column'};
  ${({ alignSelf }) => (alignSelf ? `align-self: ${alignSelf}` : undefined)};
  ${({ flexWrap }) => (flexWrap ? `flex-wrap: ${flexWrap}` : '')};
  ${({ justifyContent }) => (justifyContent ? `justify-content: ${justifyContent}` : undefined)};
  ${({ alignItems }) => (alignItems ? `align-items: ${alignItems}` : 'align-items: center')};
  ${({ alignContent }) => (alignContent ? `align-content: ${alignContent}` : undefined)};
  ${({ width }) => (width ? `width: ${width}` : undefined)};
  ${({ height }) => (height ? `height: ${height}` : undefined)};
  gap: ${({ gap }) => gap};
`;
